export default __webpack_public_path__ + "static/media/loryGameplay3.ed527703.png";